import { AutogenModelCountry, AutogenRowCountry } from "./autogen/AutogenModelCountry";

export class ModelCountry extends AutogenModelCountry<RowCountry> {
	constructor() {
		super(RowCountry);
	}
}

export class RowCountry extends AutogenRowCountry {
}